import { CookieCategory } from '../types/cookies';

export const cookieCategories: CookieCategory[] = [
  {
    id: 'essential',
    name: 'Essentielle Cookies',
    description: 'Diese Cookies sind für die Grundfunktionen der Website erforderlich und können nicht deaktiviert werden.',
    required: true
  },
  {
    id: 'analytics',
    name: 'Analyse Cookies',
    description: 'Diese Cookies ermöglichen es uns, die Nutzung der Website zu analysieren und das Benutzererlebnis zu verbessern.'
  },
  {
    id: 'marketing',
    name: 'Marketing Cookies',
    description: 'Diese Cookies werden verwendet, um Werbung relevanter für Sie zu gestalten und Ihre Interessen besser zu verstehen.'
  }
];